export { HostName as MetaOsHubHostName, HostClientType as MetaOsHubHostClientType } from '@microsoft/teams-js';

/** @deprecated(reason: 'Use MetaOsHubHostName instead') */
export enum MetaOsHubName {
  Teams = 'teams',
  Outlook = 'outlook',
  Office = 'office',
}
